module.exports = {"StatusCode":200,"Payload":"[{\"_id\":\"some-id\",\"hostedZoneId\":false,\"name\":\"some-name\",\"tld\":\".com\",\"managed\":true,\"purchased\":true,\"operationId\":\"some-id\",\"autoRenew\":false,\"expired\":false,\"planPrice\":3,\"records\":[],\"status\":\"IN_PROGRESS\"}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/purchaseNewDomain.json
// module id = 8xHi
// module chunks = 0